import logo from "./logo.svg";
import "./App.css";
import SmartObjectPlayer from "./pages/SmartObjectPlayer";

function App() {
  return (
    <div className="App">
      <SmartObjectPlayer />
    </div>
  );
}

export default App;
